import { HttpClient } from '../../httpClient'
import { OpalApiRequestParams } from '../../schema'

interface DeleteIntegrationOptionValueArguments {
  params: OpalApiRequestParams<'DeleteIntegrationOptionValueV3'>
}

// The endpoint returns a `204` with no body, so the response is hard coded
// to `null`.
export async function deleteIntegrationOptionValue({
  params,
}: DeleteIntegrationOptionValueArguments): Promise<null> {
  const url = new URL(
    `/v3/integration_option_values/${params.path.integration_option_value_id}`,
    window.location.origin
  )

  return HttpClient()
    .delete(url.toString())
    .then(() => null)
}
